import { render, staticRenderFns } from "./LoginGrp.vue?vue&type=template&id=1ab2bcf8&scoped=true&"
import script from "./LoginGrp.vue?vue&type=script&lang=js&"
export * from "./LoginGrp.vue?vue&type=script&lang=js&"
import style0 from "./LoginGrp.vue?vue&type=style&index=0&id=1ab2bcf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2bcf8",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QColor} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QColor})
